module.exports = __webpack_public_path__ + "Broccolo-iqm.jpg";